/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceSection } from './InsuranceSection';
import {
    InsuranceSectionFromJSON,
    InsuranceSectionFromJSONTyped,
    InsuranceSectionToJSON,
    InsuranceSectionToJSONTyped,
} from './InsuranceSection';

/**
 * 
 * @export
 * @interface ServiceTypeDetailItem
 */
export interface ServiceTypeDetailItem {
    /**
     * 
     */
    insurance_sections?: Array<InsuranceSection>;
}

/**
 * Check if a given object implements the ServiceTypeDetailItem interface.
 */
export function instanceOfServiceTypeDetailItem(value: object): value is ServiceTypeDetailItem {
    return true;
}

export function ServiceTypeDetailItemFromJSON(json: any): ServiceTypeDetailItem {
    return ServiceTypeDetailItemFromJSONTyped(json, false);
}

export function ServiceTypeDetailItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceTypeDetailItem {
    if (json == null) {
        return json;
    }
    return {
        
        'insurance_sections': json['insurance_sections'] == null ? undefined : ((json['insurance_sections'] as Array<any>).map(InsuranceSectionFromJSON)),
    };
}

export function ServiceTypeDetailItemToJSON(json: any): ServiceTypeDetailItem {
    return ServiceTypeDetailItemToJSONTyped(json, false);
}

export function ServiceTypeDetailItemToJSONTyped(value?: ServiceTypeDetailItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insurance_sections': value['insurance_sections'] == null ? undefined : ((value['insurance_sections'] as Array<any>).map(InsuranceSectionToJSON)),
    };
}

